import { api } from './api'

function assertSuccess(body: { success?: boolean; message?: string; data?: unknown }) {
  if (!body?.success) {
    const err = new Error(body?.message || 'Request failed') as Error & { code?: string }
    throw err
  }
  return body.data
}

function apiError(e: unknown) {
  const err = e as { response?: { data?: { message?: string; error?: { code?: string } }; status?: number }; message?: string }
  const next = new Error(err.response?.data?.message || err.message || 'Request failed') as Error & {
    code?: string
    status?: number
  }
  next.code = err.response?.data?.error?.code
  next.status = err.response?.status
  return next
}

export type PlatformImprintLocaleContent = {
  intro?: string
  company?: {
    name?: string
    legalForm?: string
    representedBy?: string
    onlinePresence?: string
    address?: string
  }
  contact?: { phones?: string[]; emails?: string[] }
  commercialRegister?: {
    court?: string
    registerNumber?: string
    vatId?: string
    vatNote?: string
  }
  contentResponsible?: { name?: string; address?: string }
  euDispute?: { showOdrLink?: boolean; body?: string }
  consumerArbitration?: { body?: string }
  footerNote?: string
}

export type PlatformImprintDocument = {
  defaultLocale: string
  locales: Record<string, PlatformImprintLocaleContent>
  availableLocales?: string[]
}

export const PLATFORM_IMPRINT_LOCALES = ['en', 'de', 'es'] as const

export async function fetchAdminPlatformImprint(): Promise<PlatformImprintDocument> {
  try {
    const { data } = await api.get('/admin/platform/imprint')
    return assertSuccess(data) as PlatformImprintDocument
  } catch (e) {
    throw apiError(e)
  }
}

export async function patchAdminPlatformImprint(body: {
  defaultLocale?: string
  locales?: Record<string, PlatformImprintLocaleContent>
}): Promise<PlatformImprintDocument> {
  try {
    const { data } = await api.patch('/admin/platform/imprint', body)
    return assertSuccess(data) as PlatformImprintDocument
  } catch (e) {
    throw apiError(e)
  }
}
